import { responseSingle, responseCollection } from '@/store/interfaces/json-api/generics';
/* eslint-disable @typescript-eslint/no-explicit-any */

import { GetterTree, ActionTree, MutationTree } from 'vuex';
import bankAccountModule from './childrens/bankAccount';
import {
  CompanyState,
  EnterpriceAddress,
  EnterpriceCommissions,
  CompanyParams,
  companyProfile
} from '@/store/interfaces/company';
import { RootState } from '@/store/interfaces/rootState';
import companyType from '@/store/types/company';
import { http } from '@/util/HTTP';
import Axios, { AxiosResponse, AxiosError } from 'axios';
import document from '../types/document';
import { TeipNotifications } from '@/util/teipNotifications';

const namespaced = true;

const initialState = (): CompanyState => {
  return {
    companies: {
      data: [],
      pagination: {},
    },
    companiesProfile: {
      data: [],
      pagination: {},
    },
    singleCompany: {
      id: '',
      membership_status: 'inactive',
      membership_validation: 'yes',
      state_code: '',
      taxpayer_type: 'non',
      billing_comment: '',
      artificial_person: false,
      liquidation_kind: {
        name: '',
        slug: '',
      },
      company_profile_id: '',
      bank_account: {
        account_number: '',
        account_type: 'current',
        bank_id: '',
        name: '',
        billing_type: 'fiscal_credit',
        account_holder: '',
        billing_address: '',
        contact: {
          email: '',
          name: '',
          phone: '',
          phone2: '',
        },
        contact_id: '',
      },
      business_name: '',
      commission: {
        rate: 0,
        start_at: '',
        liquidation_period: '',
        minimum_order_value: 0,
        renewal: 'automatic',
      },
      address: {
        description: '',
        phone: '',
        phone_alternative: '',
        state_code: '',
      },
      contacts: [],
      branches_count: 0,
      commerces_count: 0,
      created_at: '',
      business_turn: '',
      company_profile: null,
      liquidation_kind_id: null,
      name: '',
      fixed_withholding: false,
      business_activity_summary: null,
    },
    newcompanysaved: {},
    newcompanyparams: {
      model: {
        business_name: '',
        artificial_person: false,
        membership_status: 'inactive',
        membership_validation: 'yes',
        taxpayer_type: 'non',
        state_code: '',
        business_turn: '',
        liquidation_kind_id: '',
        billing_comment: '',
        name: '',
        fixed_withholding: false,
        business_activity_summary: '',
      },
      contacts: [
        {
          name: '',
          email: '',
          phone: '',
          contact_kind_id: '',
        },
        {
          name: '',
          email: '',
          phone: '',
          contact_kind_id: '',
        }
      ],
      address: {
        description: '',
        phone: '',
        state_code: '',
      },
      commission: {
        rate: 3,
        start_at: '',
        liquidation_period: 'daily',
        minimum_order_value: 0.0,
        renewal: 'automatic',
      },
    },
    clean: false,
    companies_by_commerce: {
      data: [],
      pagination: {},
    },
  };
};
const state: CompanyState = initialState();

const getters: GetterTree<CompanyState, RootState> = {
  [companyType.getters.GET_COMPANY]: state => {
    return state.companies;
  },
  [companyType.getters.GET_SINGLE_COMPANY]: state => {
    return state.singleCompany;
  },
  [companyType.getters.GET_NEW_COMPANY_PARAMS]: state => {
    return state.newcompanyparams;
  },
  [companyType.getters.GET_CLEAN]: state => {
    return state.clean;
  },
  [companyType.getters.GET_COMPANIES_BY_COMMERCE]: state => {
    return state.companies_by_commerce;
  },
  [companyType.getters.GET_COMPANIES_PROFILE_LIST]: state => {
    return state.companiesProfile;
  },
};
const mutations: MutationTree<CompanyState> = {
  [companyType.mutations.SET_COMPANY]: (
    state,
    companies: responseCollection<CompanyParams>
  ) => {
    state.companies.data = companies.data;
    state.companies.pagination = companies.meta.pagination;
  },
  [companyType.mutations.SET_ENTERPRISE_DATA]: (state, data) => {
    state.newcompanyparams.model = data;
  },
  [companyType.mutations.SET_NEW_COMPANY_SAVED]: (
    state,
    company: responseSingle<CompanyParams>
  ) => {
    state.newcompanysaved = company.data;
  },
  [companyType.mutations.SET_ADDRESS]: (state, address: EnterpriceAddress) => {
    state.newcompanyparams.model.state_code = address.state_code;
    state.newcompanyparams.address = address;
  },
  [companyType.mutations.SET_CONTACT]: (state, { position, contact, }) => {
    state.newcompanyparams.contacts[position] = contact;
  },
  [companyType.mutations.SET_COMMISSIONS]: (
    state,
    commissions: EnterpriceCommissions
  ) => {
    state.newcompanyparams.commission = commissions;
  },
  [companyType.mutations.SET_SINGLE_COMPANY]: (state, company: CompanyParams) => {
    state.singleCompany = company;
  },

  [companyType.mutations.SET_CLEAN_DATA]: state => {
    state.newcompanyparams = initialState().newcompanyparams;
  },
  [companyType.mutations.SET_COMPANIES_BY_COMMERCE]: (
    state,
    companies: responseCollection<CompanyParams>
  ) => {
    state.companies_by_commerce.data = companies.data;
    state.companies_by_commerce.pagination = companies.meta.pagination;
  },
  [companyType.mutations.SET_COMPANIES_PROFILE]: (
    state,
    companies: responseCollection<companyProfile>
  ) => {
    state.companiesProfile.data = companies.data;
    state.companiesProfile.pagination = companies.meta.pagination;
  },
};
const actions: ActionTree<CompanyState, RootState> = {
  [companyType.actions.UPDATE_COMPANY]: ({ commit, }, company_data) => {
    const sendData = {
      data: company_data.data,
    };
    return new Promise((resolve, reject) => {
      http
        .put(`backoffice/companies/${company_data.company_id}`, sendData)
        .then((res: AxiosResponse) => {
          commit(companyType.mutations.SET_SINGLE_COMPANY, res.data.data);
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
  [companyType.actions.SAVE_COMPANY]: (
    { commit, state, dispatch, },
    { model, images, }
  ) => {
    return new Promise((resolve, reject) => {
      http
        .post('backoffice/companies', { data: model, })
        .then((res: AxiosResponse) => {
          commit(companyType.mutations.SET_NEW_COMPANY_SAVED, res.data);
          commit(companyType.mutations.SET_CLEAN_DATA);

          commit(companyType.mutations.SET_SINGLE_COMPANY, res.data.data);
          state.clean = true;
          const dataToSaveImages = {
            company_id: res.data.data.id,
            contact_id: res.data.data.contacts[0].id,
            images,
          };
          dispatch(
            companyType.actions.SAVE_DOCUMENTS_OF_COMPANY,
            dataToSaveImages
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        })
        .finally(() => {
          state.clean = false;
        });
    });
  },
  [companyType.actions.DELETE_COMPANY_CONTACT_DOCUMENTS]: (_, { id, referenceUrl, }) => {
    return new Promise((resolve, reject) => {
      http
        .delete(`backoffice/${referenceUrl}/${id}`)
        .then((res: AxiosResponse) => {
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },

  [companyType.actions.SAVE_DOCUMENTS_OF_COMPANY]: (
    _,
    { company_id, contact_id, images, }
  ) => {
    const documents = images;
    const notification = new TeipNotifications();
    documents.map((doc: any) => {
      if (doc.url === 'company_documents') {
        doc.register_document_data.company_id = company_id;
      } else {
        doc.register_document_data.contact_id = contact_id;
      }

      const headers = doc.data.headers;
      Axios.put(doc.data.url, doc.image, {
        headers,
      }).then(() => {
        http
          .post(`backoffice/${doc.url}`, {
            data: doc.register_document_data,
          })
          .catch(() => {
            notification.warning(doc.image.name, '¡Error al subir!');
          });
      });
    });
  },

  [companyType.actions.COMPANY_LIST]: (
    { commit, },
    queryParams = 'per_page=100'
  ) => {
    return new Promise((resolve, reject) => {
      http
        .get(`backoffice/companies?${queryParams}`)
        .then((res: AxiosResponse) => {
          resolve(res);
          commit(companyType.mutations.SET_COMPANY, res.data);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
  [companyType.actions.COMPANIES_PROFILE]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      http
        .get('backoffice/company_profiles')
        .then((res: AxiosResponse) => {
          resolve(res);
          commit(companyType.mutations.SET_COMPANIES_PROFILE, res.data);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
  [companyType.actions.SINGLE_COMPANY]: ({ commit, }, id = '') => {
    return new Promise((resolve, reject) => {
      http
        .get(`backoffice/companies/${id}`)
        .then((res: AxiosResponse) => {
          resolve(res);
          commit(companyType.mutations.SET_SINGLE_COMPANY, res.data.data);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
  [companyType.actions.COMPANY_DOCUMENTS]: (
    { commit, },
    { url, data, }
  ) => {
    http
      .post(`backoffice/${url}`, {
        data,
      })
      .then((result: AxiosResponse) => {
        commit(
          `documentModule/${document.mutations.SET_SINGLE_DOCUMENT_IMAGE}`,
          result.data.data,
          {
            root: true,
          }
        );
      });
  },
  [companyType.actions.COMPANIES_BY_COMMERCE_LIST]: (
    { commit, },
    { query, commerce_id, }
  ) => {
    return new Promise((resolve, reject) => {
      http
        .get(`backoffice/commerces/${commerce_id}/companies?${query}`)
        .then((res: AxiosResponse) => {
          resolve(res);
          commit(companyType.mutations.SET_COMPANIES_BY_COMMERCE, res.data);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
  modules: {
    bankAccount: bankAccountModule,
  },
};
